import { useLang, useT } from "../lang/LangContext";

export function Header() {
  const { lang, setLang } = useLang();
  const t = useT();

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 16,
        padding: "14px 20px",
        background: "var(--bg)",
        borderBottom: "3px solid var(--fg)",
      }}
    >
      <a
        href="#top"
        style={{
          fontFamily: "'Archivo Black',sans-serif",
          fontSize: 18,
          letterSpacing: "-0.02em",
          color: "var(--fg)",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <span
          className="blip-dot"
          style={{
            display: "inline-block",
            width: 14,
            height: 14,
            background: "var(--accent)",
          }}
        />
        0xRODRIGO
      </a>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ display: "flex", border: "3px solid var(--fg)" }}>
          <button
            onClick={() => setLang("en")}
            style={{
              fontFamily: "'Space Mono',monospace",
              fontWeight: 700,
              fontSize: 12,
              letterSpacing: "0.1em",
              padding: "6px 10px",
              border: 0,
              cursor: "pointer",
              background: lang === "en" ? "var(--accent)" : "transparent",
              color: lang === "en" ? "var(--bg)" : "var(--fg)",
            }}
          >
            EN
          </button>
          <button
            onClick={() => setLang("pt")}
            style={{
              fontFamily: "'Space Mono',monospace",
              fontWeight: 700,
              fontSize: 12,
              letterSpacing: "0.1em",
              padding: "6px 10px",
              border: 0,
              cursor: "pointer",
              background: lang === "pt" ? "var(--accent)" : "transparent",
              color: lang === "pt" ? "var(--bg)" : "var(--fg)",
            }}
          >
            PT
          </button>
        </div>
        <a
          href="/Rodrigo_Ferreira_Resume.pdf"
          download
          className="btn btn-resume-badge"
          style={{
            fontSize: 12,
            letterSpacing: "0.08em",
            background: "var(--fg)",
            color: "var(--bg)",
            padding: "6px 12px",
            boxShadow: "5px 5px 0 var(--accent)",
          }}
        >
          {t("RESUME.PDF", "CURRÍCULO.PDF")}
        </a>
      </div>
    </header>
  );
}
